export default {
  title: {
    id: 'bo_seller.kyb.account_requester.title',
    defaultMessage: 'Account requester details',
  },
  description: {
    id: 'bo_seller.kyb.account_requester.description',
    defaultMessage:
      'Fill out details for the account requester, that is, the person responsible for opening the account.',
  },
  saveButton: {
    id: 'bo_seller.kyb.account_requester.save_button',
    defaultMessage: 'Save',
  },
} as const
